'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _css = require('antd/lib/input/style/css');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _css2 = require('antd/lib/form/style/css');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
                                                                                                                                                                                                                                                                   * 关闭订单价格按钮及弹出表单
                                                                                                                                                                                                                                                                   */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _refund_input = require('./refund_input');

var _refund_input2 = _interopRequireDefault(_refund_input);

var _modal_form = require('./modal_form');

var _modal_form2 = _interopRequireDefault(_modal_form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var OrderClose = _react2.default.createClass({
    displayName: 'OrderClose',

    propTypes: {
        order: _react.PropTypes.object.isRequired,
        form: _react.PropTypes.object.isRequired
    },
    onOk: function onOk(form) {

        this.props.onSubmit(form.getFieldsValue());
    },
    render: function render() {
        var _props = this.props,
            order = _props.order,
            form = _props.form;
        var getFieldDecorator = form.getFieldDecorator;

        var formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 }
        };
        // const payment = parseInt(order.total_fee); // 实付金额
        return _react2.default.createElement(
            _modal_form2.default,
            { form: form, onOk: this.onOk.bind(this, form), title: '\u5173\u95ED\u8BA2\u5355' },
            _react2.default.createElement(
                _form2.default,
                null,
                _react2.default.createElement(
                    FormItem,
                    _extends({}, formItemLayout, { label: '\u5173\u95ED\u539F\u56E0' }),
                    getFieldDecorator('reason', {
                        rules: [{ required: true, message: '请输入订单关闭原因!' }]
                    })(_react2.default.createElement(_input2.default, { type: 'textarea' }))
                )
            )
        );
    }
});

exports.default = _form2.default.create()(OrderClose);


//////////////////
// WEBPACK FOOTER
// ./src/js/components/order_close.js
// module id = 1311
// module chunks = 0